import React from 'react';
import InfoPage from './InfoPage';

const FAQPage = () => {
  return <InfoPage type="faq" />;
};

export default FAQPage;